import { render, staticRenderFns } from "./ProjectGroupEdit.vue?vue&type=template&id=cc96e816&"
import script from "./ProjectGroupEdit.vue?vue&type=script&lang=js&"
export * from "./ProjectGroupEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports